<h1 md-dialog-title>{{data.title}}</h1>
<div md-dialog-content class="dialog-content"><span [innerHtml]="htmlContent | sanitizeHtml"></span></div>
<div md-dialog-actions class="dialog-actions">
  <button mat-stroked-button color="primary" (click)="dialogRef.close(true)">{{data.confirmText}}</button>
  <button *ngIf="data.thirdButtonText" mat-stroked-button color="primary" (click)="dialogRef.close('thirdAction')">{{data.thirdButtonText}}</button>
  <button mat-stroked-button color="primary" (click)="dialogRef.close(false)">{{data.cancelText}}</button>
  <button *ngIf="data.abortText" mat-stroked-button color="primary" (click)="dialogRef.close('abort')">{{data.abortText}}</button>
</div>